// extracted by mini-css-extract-plugin
export default {"head_container":"Category_head_container__wlXT8","title":"Category_title__FcV7t","link":"Category_link__R9dsF"};